/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_Not_SentInputs */

const en_error_invitation_not_sent = /** @type {(inputs: Error_Invitation_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email did not leave. Try again in a few minutes.`)
};

/**
* | output |
* | --- |
* | "The email did not leave. Try again in a few minutes." |
*
* @param {Error_Invitation_Not_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_invitation_not_sent = /** @type {((inputs?: Error_Invitation_Not_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_Not_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_invitation_not_sent(inputs)
});